import { SHOW_INVOICE_DETAILS } from 'actionTypes/invoiceDetailsActionTypes';

// action creators
export const setInvoiceDetails = (show) => ({
  type: SHOW_INVOICE_DETAILS,
  payload: show,
});
